import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { DynamicLayout } from '../../formbuilder';

const results = {
  next: {
    next: newStepValue,
    description: 'Next',
  },
  error: {
    next: newStepValue,
    description: 'Error',
  },
};

export const chatHubIntegration: DynamicLayout = {
  json: {
    menu: {
      menuType: 'chatHubIntegration',
      chatHubIntegration: {
        providerId: '',
        instanceId: '',
        messageEndpoint: '',
        messageParameterId: '',
        mediaEndpoint: '',
        mediaParameterId: '',
        messageParameters: {},
        mediaParameters: {},
      },
      results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: [],
  groups: [],
  layout: {},
  data: {},
};
